<template>
    <img
        src="@/assets/images/Logo_FullColor.svg"
        alt="Logo"
        height="100"
        class="rotating-logo" />
</template>

<style scoped>
.rotating-logo {
    animation: rotate 2s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
